import React from 'react';
import PropTypes from 'prop-types';
import { usePropsContext } from '@uhg-abyss/web/hooks/usePropsContext';
import { SelectInput } from '@uhg-abyss/web/ui/SelectInput';
import { styled } from '@uhg-abyss/web/tools/styled';

const StyledLabel = styled('label', {
  fontSize: '$md',
  color: '$gray8',
});

export const CareProviders = ({
  selectedProvider,
  setSelectedProvider,
  careProviders,
  isCareProvidersLoading,
}) => {
  const { events } = usePropsContext();

  const { taxIdNumber, servicingProviderName, servicingProviderMpin } =
    selectedProvider;
  const handleChange = (newCareProviderMpin) => {
    // check if selection is same as initial
    if (newCareProviderMpin !== selectedProvider?.servicingProviderMpin) {
      const careProviderMatch = (careProviders || []).find(
        (careProvider) => careProvider.mpin === newCareProviderMpin
      );
      setSelectedProvider((prevSelection) => ({
        ...prevSelection,
        servicingProviderMpin: careProviderMatch.mpin,
        servicingProviderName: careProviderMatch.name,
      }));
    }

    events.onCareProviderChange(newCareProviderMpin);
  };

  return (
    <React.Fragment>
      <StyledLabel
        id="care-provider-header"
        data-testid="care-provider-header"
        htmlFor="provider-select-providers"
        className={labelClassName}
        data-uhc-brand="font--semibold"
      >
        Care Provider
      </StyledLabel>
      <SelectInput
        id="provider-select-providers"
        data-testid="provider-select-providers"
        aria-label="change care provider"
        aria-labelledby="care-provider-header"
        aria-required="true"
        enableOutsideScroll
        isLoading={isCareProvidersLoading}
        isDisabled={careProviders.length === 0 || !taxIdNumber}
        value={servicingProviderMpin}
        options={
          careProviders.length > 0
            ? careProviders
            : [
                {
                  mpin: servicingProviderMpin,
                  label: `${servicingProviderName} (${servicingProviderMpin})`,
                },
              ]
        }
        placeholder="Select Care Provider..."
        valueKey="mpin"
        onChange={handleChange}
        validators={{ required: (value) => !value }}
      />
    </React.Fragment>
  );
};

CareProviders.propTypes = {
  selectedProvider: PropTypes.shape({
    organizationId: PropTypes.string,
    corporateProviderMpin: PropTypes.string,
    taxIdNumber: PropTypes.string,
    uhcProviderId: PropTypes.string,
    userId: PropTypes.string,
    uniqueId: PropTypes.string,
    servicingProviderMpin: PropTypes.string,
    servicingProviderName: PropTypes.string,
  }),
  setSelectedProvider: PropTypes.func.isRequired,
  careProviders: PropTypes.arrayOf(PropTypes.shape({})),
  isCareProvidersLoading: PropTypes.bool,
};

CareProviders.defaultProps = {
  selectedProvider: null,
  careProviders: [],
  isCareProvidersLoading: false,
};
